import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var getFetchWithAgent = function () {
  var _ref = _asyncToGenerator(function* (url, options) {
    return globalThis.fetch(url, options);
  });
  return function getFetchWithAgent(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getNodeFetch = () => {
  return getFetchWithAgent;
};